import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylish%20fashion%20lifestyle%20flat%20lay%20with%20clothing%20items%20and%20accessories%20on%20a%20light%20wooden%20surface%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20and%20sage%20green%20color%20palette%2C%20minimalist%20editorial%20photography%2C%20elegant%20composition%20with%20organic%20textures%20and%20gentle%20shadows&width=1800&height=1200&seq=hero-bg-usfans-v2r44m&orientation=landscape"
        alt="USFansSpreadsheet workspace"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div className="animate-fade-in-up">
            <div className="flex items-center gap-2 mb-6">
              <div className="flex -space-x-2">
                {[1, 2, 3].map((i) => (
                  <div
                    key={i}
                    className="w-9 h-9 rounded-full border-2 border-white/80 bg-secondary-300 flex items-center justify-center"
                  >
                    <i className="ri-user-line text-white text-xs"></i>
                  </div>
                ))}
              </div>
              <span className="text-white/90 text-sm font-medium ml-3">10 000+ użytkowników</span>
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold font-heading text-white leading-tight mb-4 drop-shadow-lg">
              USFansSpreadsheet
            </h1>
            <p className="text-xl md:text-2xl lg:text-3xl font-light font-heading text-white/95 mb-3 drop-shadow-md">
              Kompletny przewodnik 2026
            </p>
            <p className="text-base md:text-lg text-white/85 max-w-lg mb-8 leading-relaxed drop-shadow-sm">
              Analizuj dane. Porównuj rozwiązania. Odkrywaj najlepsze narzędzia. Twój zaufany przewodnik po świecie arkuszy kalkulacyjnych.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white text-primary-700 font-semibold text-sm hover:bg-background-100 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                usfans spreadsheet
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border-2 border-white/70 text-white font-semibold text-sm hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                buy it now
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-4 mt-8">
              {['Aktualizowane codziennie', 'Porównania ekspertów', 'Bezpieczne rozwiązania'].map((item) => (
                <span key={item} className="flex items-center gap-1.5 text-white/85 text-xs md:text-sm">
                  <i className="ri-check-line text-green-400"></i>
                  {item}
                </span>
              ))}
            </div>
          </div>

          <div className="hidden lg:flex flex-col items-end">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 max-w-sm animate-fade-in-up animation-delay-200">
              <p className="text-white/90 text-base leading-relaxed">
                <strong className="text-white font-semibold">USFansSpreadsheet</strong> to największe centrum wiedzy o arkuszach kalkulacyjnych w Polsce. Nasze przewodniki i rankingi pomogły już ponad <strong className="text-white">10 000 użytkowników</strong> znaleźć idealne narzędzia do analizy danych.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#kategorie"
          className="flex flex-col items-center gap-2 text-white/70 hover:text-white transition-colors cursor-pointer"
        >
          <span className="text-xs font-medium">Odkryj kategorie</span>
          <i className="ri-arrow-down-line animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}